import PartnerModel              from '@models/website/PartnerModel';
import PartnershipTypeModel      from '@models/website/PartnershipTypeModel';
import WebsiteEntertainmentModel from '@models/website/WebsiteEntertainmentModel';
import PartnershipStatusModel    from '@models/website/PartnershipStatusModel';
import doc                       from '@widesk-core/decorators/doc';
import WebsiteServiceModel       from '@/models/WebsiteServiceModel';
import Blamable                  from '@/models/traits/Blamable';
import { Addable }               from '@widesk-core/decorators/addable';
import { Editable }              from '@widesk-core/decorators/editable';
import { Deletable }             from '@widesk-core/decorators/deletable';
import { Timestampable }         from '@widesk-core/decorators/timestampable';

@doc.path('/partnerships/{?id}')
@doc.addable
@doc.editable
@doc.deletable
@doc.timestampable
abstract class AbstractPartnershipModel extends Blamable(WebsiteServiceModel) {
	declare protected _tsFilters: {
		'partial': string;
		'existsInContentToPublish': string;
		'createdAt[before]': string | Date;
		'createdAt[strictly_before]': string | Date;
		'createdAt[after]': string | Date;
		'createdAt[strictly_after]': string | Date;
		'updatedAt[before]': string | Date;
		'updatedAt[strictly_before]': string | Date;
		'updatedAt[after]': string | Date;
		'updatedAt[strictly_after]': string | Date;
		'partner': id;
		'partnershipType': id;
		'websiteEntertainment': id;
		'position': string;
		'partnershipStatus': string;
		'slug': id;
		'participationPartnerships.participation': id;
		'eventPartnerships.event': id;
		'search': string;
	};

	declare private _tsSorts: {
		daisukiCount: string;
		id: string;
		position: string;
		createdAt: string;
		updatedAt: string;
	};

	@doc.model(PartnerModel) declare partner: PartnerModel;
	@doc.model(PartnershipTypeModel)
	declare partnershipType: PartnershipTypeModel;
	@doc.string declare slug: string;
	@doc.number declare position: number;
	@doc.model(WebsiteEntertainmentModel)
	declare websiteEntertainment: WebsiteEntertainmentModel;
	@doc.model(PartnershipStatusModel)
	declare partnershipStatus: PartnershipStatusModel;
	declare abstract entity: unknown;
}

interface AbstractPartnershipModel
	extends Addable,
		Editable,
		Deletable,
		Timestampable {}

export default AbstractPartnershipModel;
